export default __webpack_public_path__ + "static/trendmicro-9c8970e01188b632047d14d354fa1305.jpg";